import { useMutation } from "@apollo/client";
import FileDownload from "@mui/icons-material/FileDownload";
import { Button } from "@mui/material";
import { useAlerts } from "components/Alerts/AlertProvider";
import { gql } from "generated-graphql";
import { SortModel } from "generated-graphql/graphql";
import { useEffect } from "react";

export const CHEMICAL_FACILITIES_EXPORT_GRID_TO_CSV = gql(`
  mutation ExportChemicalFacilitiesGridToCsv($search: String, $sort: [SortModel!]) {
    exportChemicalFacilitiesGridToCsv(search: $search, sort: $sort) {
      success
      errorMsg
      downloadUrl
    }
  }
`);

export const EXPORT_WORKFLOW_ACTIVITIES_TO_CSV = gql(`
  mutation ExportWorkflowActivitiesToCsv($search: String, $sort: [SortModel!]) {
    exportWorkflowActivitiesToCsv(search: $search, sort: $sort) {
      success
      errorMsg
      downloadUrl
    }
  }
`);

type ExportGridToCsvButtonProps = {
  search?: string;
  sort?: Array<SortModel>;
  grid: "workflowActivities" | "chemicalFacilities"; // Made required since we removed the default case
};

export function ExportGridToCsvButton(props: ExportGridToCsvButtonProps) {
  const alert = useAlerts();
  let mutationToUse: any;
  if (props.grid === "chemicalFacilities") {
    mutationToUse = CHEMICAL_FACILITIES_EXPORT_GRID_TO_CSV;
  } else if (props.grid === "workflowActivities") {
    mutationToUse = EXPORT_WORKFLOW_ACTIVITIES_TO_CSV;
  }

  const [mutate, { data, loading }] = useMutation(mutationToUse);

  function handleClick() {
    mutate({
      variables: {
        search: props.search,
        sort: props.sort,
      },
    });
  }

  let result: { success?: boolean; errorMsg?: string; downloadUrl?: string } | undefined;
  if (props.grid === "chemicalFacilities") {
    result = data?.exportChemicalFacilitiesGridToCsv;
  } else if (props.grid === "workflowActivities") {
    result = data?.exportWorkflowActivitiesToCsv;
  }

  useEffect(() => {
    if (result?.success) {
      alert.success("Successfully generated the export");
    } else if (result?.errorMsg) {
      alert.error(`There was a problem generated the export: ${result.errorMsg}`);
    }
  }, [alert, result?.errorMsg, result?.success]);

  useEffect(() => {
    if (result?.downloadUrl) {
      window.open(result.downloadUrl, "_blank");
    }
  }, [result?.downloadUrl]);

  return (
    <Button size="medium" loading={loading} sx={{ minWidth: 0 }} onClick={handleClick}>
      <FileDownload />
    </Button>
  );
}
